import { render, staticRenderFns } from "./ConformationPaymentDetails.vue?vue&type=template&id=5d074e00&"
import script from "./ConformationPaymentDetails.vue?vue&type=script&lang=js&"
export * from "./ConformationPaymentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports